// Модальное окно добавить во вкладке Анализ результатов
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CFormSelect,
  CFormInput,
  CFormCheck,
} from '@coreui/react';

const AddResultModal = ({ visible, onClose, onSave }) => {
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState('');
  const [dateMeasurement, setDateMeasurement] = useState('');
  const [tiltValue, setTiltValue] = useState('');
  const [noDayInfo, setNoDayInfo] = useState(false);
  const [noMonthInfo, setNoMonthInfo] = useState(false);

  const token = localStorage.getItem('token');

  // Загрузка организаций с API
  useEffect(() => {
    if (visible) {
      axios
        .get('/api/typetable/?ntype=49', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          console.log('Данные от API:', response.data);
          setOrganizations(response.data || []);
        })
        .catch((error) => {
          console.error('Ошибка загрузки организаций:', error);
        });
    }
  }, [visible, token]);

  const handleSave = () => {
    onSave({
      organization: selectedOrg,
      date: dateMeasurement,
      tilt: tiltValue,
      noDay: noDayInfo,
      noMonth: noMonthInfo,
    });
  };

  return (
    <CModal visible={visible} onClose={onClose}>
      <CModalHeader>
        <CModalTitle>Добавить результат</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div className="mb-3 d-flex align-items-center">
          <label className="form-label mb-0" style={{ width: '160px' }}>
            Наименование организации
          </label>
          <CFormSelect
            value={selectedOrg}
            onChange={(e) => setSelectedOrg(e.target.value)}
            style={{ width: '250px' }}
          >
            <option value="">Выберите организацию</option>
            {organizations.map((org) => (
              <option key={org.Id} value={org.Id}>
                {org.Name}
              </option>
            ))}
          </CFormSelect>
        </div>

        <div className="mb-3 d-flex align-items-center">
          <label className="form-label mb-0" style={{ width: '160px' }}>
            Дата проведения измерений
          </label>
          <CFormInput
            type="date"
            value={dateMeasurement}
            onChange={(e) => setDateMeasurement(e.target.value)}
            style={{ width: '150px' }}
          />
          <label className="form-label mb-0 ms-3" style={{ width: '120px' }}>
            Крен объекта, мм
          </label>
          <CFormInput
            type="text"
            value={tiltValue}
            onChange={(e) => setTiltValue(e.target.value)}
            style={{ width: '100px' }}
          />
        </div>

        <div className="mb-3">
          <CFormCheck
            label="Нет информации о дне проведения измерений"
            checked={noDayInfo}
            onChange={(e) => setNoDayInfo(e.target.checked)}
          />
        </div>
        <div className="mb-3">
          <CFormCheck
            label="Нет информации о дне и месяце измерений"
            checked={noMonthInfo}
            onChange={(e) => setNoMonthInfo(e.target.checked)}
          />
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Справочники
        </CButton>
        <div className="ms-auto">
          <CButton color="success" onClick={handleSave} className="me-2">
            ОК
          </CButton>
          <CButton color="secondary" onClick={onClose}>
            Отмена
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  );
};

export default AddResultModal;